import { Trans, useTranslation } from 'react-i18next';
import React, { useCallback } from 'react';
import { CommonModal } from '../Modal/CommonModal';
import styles from './index.module.scss';
import clsx from 'clsx';
import { MintWeb3IdBtn } from '../MintWeb3IdBtn';
import { useHistory } from 'react-router-dom';

export const TrialModal = ({ on, turnoff }: { on: boolean; turnoff: () => void }) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = useCallback(() => {
    history.push('/settings');
    turnoff();
  }, [history, turnoff]);

  return (
    <CommonModal on={on} turnOff={turnoff} className={styles.modalClassName}>
      <div className={styles.header}>
        <div className={styles.headerText}>{t('TrialModal.13slkst')}</div>
      </div>
      <div className={styles.content}>
        <div className={styles.listItem}>
          <div className={styles.dot} />
          <div className={styles.text}>{t('TrialModal.13xyn2l')}</div>
        </div>
        <div className={styles.listItem}>
          <div className={styles.dot} />
          <div className={styles.text}>{t('TrialModal.jibfap')}</div>
        </div>
        <div className={clsx(styles.listItem, styles.guide)}>
          <div className={styles.dot} />
          <div className={styles.text}>
            <Trans i18nKey="TrialModal.mintGuide">
              Update your account and get permanent access to unlimited social features on
              DeBank(without social cap) and other Web3ID benefits by{' '}
              <span className={styles.mint} onClick={handleClick}>
                minting your Web3 ID.
              </span>
            </Trans>
          </div>
        </div>
        <div className={styles.mintBtnContainer}>
          <MintWeb3IdBtn className={styles.btn} onClick={() => turnoff()} />
        </div>
      </div>
    </CommonModal>
  );
};
